import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScopeField, ErpScopeMode } from "../ErpScope";
import AccountHierarchyView from "../components/AccountHierarchyView";

interface Props extends NSARouterMakerResult, ErpRouterProps { }

export default class AccountListPage extends Component<Props>
{
    override render()
    {
        return (
            <ErpLayout
                {...this.props}
                mode={ErpScopeMode.Filter}
                fields={[ErpScopeField.Company, ErpScopeField.Branch]}
                pages={{
                    entity: ErpEntities.account(this.props),
                    list: {
                        ui: {
                            default_mode: "Hierarchy",
                            modes: {
                                Hierarchy: {
                                    getChild: () =>
                                    {
                                        debugger;
                                        return (<AccountHierarchyView {...this.props} />)
                                    },
                                    show_view: false
                                },
                            },
                        },
                    },
                }}
            >
                <></>
            </ErpLayout>
        );
    }
}